import { computed, defineComponent } from "vue";
import { useRouter } from "vue-router";
import KeiyakuInfoPanel from "./components/KeiyakuInfoPanel.vue";
import { myPageStore } from "~/store/MyPageStore";
import BukenRoomList from "~/components/BukenRoomList.vue";
import BreadcrumbList from "~/components/BreadcrumbList.vue";
import { PageID } from "~/extensions/utils/DefineTypes";
import { commonStore } from "~/store/CommonStore";
export default defineComponent({
    name: "KeiyakuInfoPage",
    components: {
        KeiyakuInfoPanel,
        BukenRoomList,
        BreadcrumbList
    },
    setup() {
        const router = useRouter();
        const nyukyokeiyaku = computed(() => myPageStore.selectedNyukyokeiyaku);
        const pageName = commonStore.pageName(PageID.keiyaku);
        const toTopPage = () => {
            router.push({ name: "top" });
        };
        const toEditPage = () => {
            router.push({ name: "shinjosho-edit", query: { nyukyokeiyakuNo: myPageStore.selectedNyukyokeiyakuNo } });
        };
        return {
            myPageStore,
            nyukyokeiyaku,
            PageID,
            pageName,
            toTopPage,
            toEditPage
        };
    }
});
